import { render, staticRenderFns } from "./grabOrders.vue?vue&type=template&id=23b8ec47&scoped=true&"
import script from "./grabOrders.vue?vue&type=script&lang=js&"
export * from "./grabOrders.vue?vue&type=script&lang=js&"
import style0 from "./grabOrders.vue?vue&type=style&index=0&id=23b8ec47&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8ec47",
  null
  
)

export default component.exports